module.exports = __webpack_public_path__ + "static/media/foto@3x.bee7a3cd.jpg";